import { AlphaTypes } from '../custom-types'
import i18n from '../../../i18n'

export const getTemplates = () =>
  [
    {
      id: 'new-input',
      name: 'new-input',
      type: 'input',
      uiOptions: {
        label: i18n.t('questionnaire_builder.text_field'),
        inputType: 'text',
      },
    },
    {
      id: 'email',
      name: 'email',
      type: 'custom',
      customControlType: 'email',
      uiOptions: {
        label: i18n.t('questionnaire_builder.email'),
        inputType: 'email',
      },
    },
    {
      id: 'new-textarea',
      name: 'new-textarea',
      type: 'custom',
      customControlType: 'textarea',
      uiOptions: {
        label: i18n.t('questionnaire_builder.long_text_field'),
      },
    },

    {
      id: 'new-dropdown',
      name: 'new-dropdown',
      type: 'custom',
      customControlType: 'shadcn-select',
      uiOptions: {
        label: i18n.t('questionnaire_builder.dropdown_field'),
        inputType: 'select',
      },
      options: [],
    },

    {
      id: 'new-date',
      name: 'new-date',
      type: 'custom',
      customControlType: 'dateInput',
      uiOptions: {
        label: i18n.t('questionnaire_builder.date_field'),
      },
    },
    {
      id: 'new-picture-choice',
      name: 'new-picture-choice',
      type: 'custom',
      customControlType: 'picture-choice',
      uiOptions: {
        label: i18n.t('questionnaire_builder.picture_choice'),
      },
      options: [],
    },
    {
      id: 'new-dynamic-radio',
      name: 'new-dynamic-radio',
      type: 'custom',
      customControlType: 'radioGroup',
      uiOptions: {
        label: i18n.t('questionnaire_builder.dynamic_radio_group'),
      },
      options: [],
    },
    {
      id: 'new-radio',
      name: 'new-radio',
      type: 'custom',
      customControlType: 'radioGroupGender',
      uiOptions: {
        label: i18n.t('questionnaire_builder.radio_field'),
      },
    },
    {
      id: 'new-toggle',
      name: 'new-toggle',
      type: 'custom',
      customControlType: 'switch',
      uiOptions: {
        label: i18n.t('questionnaire_builder.toggle_field'),
      },
    },
    {
      id: 'new-checkbox',
      name: 'new-checkbox',
      type: 'input',
      uiOptions: {
        label: i18n.t('questionnaire_builder.checkbox_field'),
        inputType: 'checkbox',
      },
    },
  ] as unknown as AlphaTypes[]

// Short text (input) - Required, min length, max length
// Long text (textarea) - Required, min length, max length
// Radio buttons - Required
// Checkbox - Required
// Drop down - Required
// Date picker - Required, min date, max date
// Toggle (Yes/No) - Required
